export default function({ app, redirect, store }, inject) {
  let notifFunc = null;
  inject('showNotif', callback => {
    notifFunc = callback;
  });
  function listenPushNotif() {
    window.$OneSignal.addListenerForNotificationOpened(data => {
      const selectedNotification = data.data;
      if (selectedNotification.action === 'profile' || selectedNotification.action === 'general') {
        redirect(app.localePath('accounts'));
      } else if (selectedNotification.action === 'claim') {
        redirect(app.localePath('products'));
      } else if (selectedNotification.action === 'policy') {
        redirect(app.localePath('products'));
      } else {
        redirect(app.localePath('index'));
      }
      listenPushNotif();
    });
  }

  function listenPushNotif2() {
    window.$OneSignal.on('notificationDisplay', data => {
      if (notifFunc !== null) {
        notifFunc(data.heading, data.content, data.type);
      }
      if (store.getters['general/getUserData'] && store.getters['user/getUserToken']) {
        store.dispatch('user/getUnreadNotifications', {
          callback: () => {},
          callbackFail: error => {
            console.log(error);
          }
        });
      }
    });
  }
  function whitelistUserNotif() {
    const user = store.getters['general/getUserData'];
    if (user) {
      const userEmail = user.email;
      if (userEmail === 'christian.haryono@qoala.id') return false;
      if (userEmail === 'christian.haryono+tester@qoala.id') return false;
      if (userEmail === 'martin@qoala.id') return false;
      if (userEmail === 'martha.gultom@qoala.id') return false;
    }
    return true;
  }
  if (process.browser) {
    window.onNuxtReady(() => {
      if (!window.isApple) {
        const OneSignal = window.$OneSignal || [];
        OneSignal.push(() => {
          OneSignal.getTags(tags => {
            console.log(tags);
          });
          OneSignal.on('subscriptionChange', isSubscribed => {
            if (!isSubscribed && whitelistUserNotif()) OneSignal.showHttpPrompt();
            if (isSubscribed && store.getters['general/getUserData'] && store.getters['general/getUserData'].email) {
              OneSignal.sendTag('email', store.getters['general/getUserData'].email, tagsSent => {
                console.log(tagsSent);
              });
            }
          });
          listenPushNotif();
          listenPushNotif2();
        });
      }
    });
  } else console.log('something wrong');
}
